import React from 'react';
import { FormControl } from '@material-ui/core';
import { MainContext } from '../../context';
import { Footer } from '../Footer';
import { SelectCircle } from '../SelectCircle';
const Spotify = require('spotify-web-api-js');
const spotifyWebApi = new Spotify();

export const CreatePlaylist = () => {
  const [filterByString, setFilterByString] = React.useState('');
  const mainContext = React.useContext(MainContext);

  React.useEffect(() => {
    if (mainContext.accessToken) {
      spotifyWebApi.setAccessToken(mainContext.accessToken);
    }
  }, []);

  React.useEffect(() => {
    mainContext.setFilterType(filterByString!);
  }, [filterByString]);

  return (
    <div className='centeredVertical'>
      <FormControl>
        <h1 className='title'>How would you like to filter?</h1>
        <p className='subtitle'>This is how we will create your playlist</p>
        <div className='optionsContainer'>
          <SelectCircle
            backgroundColor='#1abc9c'
            name='Song'
            selected={filterByString === 'song'}
            setSelected={setFilterByString}
          />
          <SelectCircle
            backgroundColor='#ff7f50'
            name='Artist'
            selected={filterByString === 'artist'}
            setSelected={setFilterByString}
          />
          <SelectCircle
            backgroundColor='#1c89bf'
            name='Genre'
            selected={filterByString === 'genre'}
            setSelected={setFilterByString}
          />
        </div>
      </FormControl>
      <Footer forwardEnabled={mainContext.filterType !== ''} forwardLink='/search' backwardLink='/home' />
    </div>
  );
};
